<template lang="pug">
  input(placeholder='name', v-model='name', @keyup.enter="sendName")
</template>

<script>
  export default {
    name: 'PlayerLoginForm',
    data() {
      return {
        name: ''
      }
    },
    methods: {
      sendName() {
        this.$emit('nameSubmitted', this.name)
        this.name = ''
      }
    },
  }
</script>

<style scoped>

</style>
